// Mock data for testing
export const mockUsers = [
  {
    id: '1',
    username: 'doctor',
    password: 'demo123',
    name: 'Dr. García'
  },
  {
    id: '2',
    username: 'admin',
    password: 'admin123',
    name: 'Admin Usuario'
  }
];

// Get today's date and a time 1.5 hours from now for demo
const getTodayDate = () => {
  const today = new Date();
  return today.toISOString().split('T')[0];
};

const getTimeInFuture = (hours) => {
  const now = new Date();
  now.setHours(now.getHours() + hours);
  return now.toTimeString().slice(0, 5);
};

export const mockAppointments = [
  {
    id: '1',
    patientName: 'María González',
    phone: '+34612345678',
    date: getTodayDate(),
    time: getTimeInFuture(1.5),
    serviceType: 'Consulta',
    reason: 'Consulta general',
    status: 'confirmed',
    reminderTime: 120, // 2 hours in minutes
    tags: ['VIP', 'Frecuente'],
    userId: '1'
  },
  {
    id: '2',
    patientName: 'Juan Pérez',
    phone: '+34623456789',
    date: '2025-07-15',
    time: '11:30',
    serviceType: 'Terapia',
    reason: 'Seguimiento',
    status: 'pending',
    reminderTime: 30, // 30 minutes
    tags: ['Primera vez'],
    userId: '1'
  },
  {
    id: '3',
    patientName: 'Ana Martínez',
    phone: '+34634567890',
    date: '2025-07-16',
    time: '09:00',
    serviceType: 'Valoración',
    reason: 'Primera consulta',
    status: 'confirmed',
    reminderTime: 60, // 1 hour
    tags: [],
    userId: '1'
  }
];

// LocalStorage keys
export const STORAGE_KEYS = {
  USERS: 'medapp_users',
  APPOINTMENTS: 'medapp_appointments',
  CURRENT_USER: 'medapp_current_user',
  PATIENT_TAGS: 'medapp_patient_tags',
  MESSAGE_TEMPLATES: 'medapp_message_templates'
};

// Initialize mock data in localStorage
export const initializeMockData = () => {
  if (!localStorage.getItem(STORAGE_KEYS.USERS)) {
    localStorage.setItem(STORAGE_KEYS.USERS, JSON.stringify(mockUsers));
  }
  if (!localStorage.getItem(STORAGE_KEYS.APPOINTMENTS)) {
    localStorage.setItem(STORAGE_KEYS.APPOINTMENTS, JSON.stringify(mockAppointments));
  }
  if (!localStorage.getItem(STORAGE_KEYS.PATIENT_TAGS)) {
    localStorage.setItem(STORAGE_KEYS.PATIENT_TAGS, JSON.stringify(DEFAULT_TAGS));
  }
  if (!localStorage.getItem(STORAGE_KEYS.MESSAGE_TEMPLATES)) {
    localStorage.setItem(STORAGE_KEYS.MESSAGE_TEMPLATES, JSON.stringify(DEFAULT_MESSAGE_TEMPLATE));
  }
};

// Predefined service types
export const SERVICE_TYPES = [
  'Consulta',
  'Terapia',
  'Valoración',
  'Seguimiento',
  'Rehabilitación',
  'Evaluación',
  'Otro'
];

// Reminder time options (in minutes)
export const REMINDER_OPTIONS = [
  { value: 5, label: '5 minutos antes' },
  { value: 10, label: '10 minutos antes' },
  { value: 15, label: '15 minutos antes' },
  { value: 20, label: '20 minutos antes' },
  { value: 30, label: '30 minutos antes' },
  { value: 60, label: '1 hora antes' },
  { value: 120, label: '2 horas antes' }
];

// Appointment statuses
export const APPOINTMENT_STATUSES = [
  { value: 'pending', label: 'Pendiente', color: 'bg-blue-100 text-blue-800 border-blue-300' },
  { value: 'confirmed', label: 'Confirmada', color: 'bg-green-100 text-green-800 border-green-300' },
  { value: 'cancelled', label: 'Cancelada', color: 'bg-red-100 text-red-800 border-red-300' },
  { value: 'cancelled_patient', label: 'Cancelada por paciente', color: 'bg-orange-100 text-orange-800 border-orange-300' },
  { value: 'no_show', label: 'No asistió', color: 'bg-gray-100 text-gray-800 border-gray-300' },
  { value: 'completed', label: 'Completada', color: 'bg-purple-100 text-purple-800 border-purple-300' }
];

// Default patient tags
export const DEFAULT_TAGS = [
  { id: '1', name: 'VIP', color: '#FFD700' },
  { id: '2', name: 'Primera vez', color: '#87CEEB' },
  { id: '3', name: 'Frecuente', color: '#90EE90' },
  { id: '4', name: 'Seguimiento', color: '#DDA0DD' },
  { id: '5', name: 'Urgente', color: '#FF6347' },
  { id: '6', name: 'Tratamiento largo', color: '#FFA500' }
];

// Default WhatsApp message template
export const DEFAULT_MESSAGE_TEMPLATE = {
  reminder: '¡Hola {paciente}! 👋\n\nTe recordamos tu cita:\n📅 Fecha: {fecha}\n🕐 Hora: {hora}\n📋 Servicio: {servicio}\n\n✅ Confirmar cita: {link_confirmar}\n❌ Cancelar cita: {link_cancelar}\n\n¡Te esperamos!\n\n---\nEnviado desde NotiMax'
};

// Recommendation types
export const RECOMMENDATION_TYPES = [
  'Tratamiento',
  'Dieta',
  'Ejercicios',
  'Medicación',
  'Seguimiento',
  'Otro'
];